/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IApiConfigure, IApiConfigureGet } from '../ApiTypes';
import LogoFW from '../components/LogoFW';
import gstyle from '../style/style.scss';

function ConfigurePage() {
  const [isGood, setIsGood] = useState<boolean | null>(null);
  const [apiConfigureContext, setApiConfigureContext] = useState<IApiConfigure | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    // czy już jest zainstalowane
    fetch('/api/v1/configure/')
      .then((r) => r.json())
      .then((data: IApiConfigureGet) => {
        if (!data.isConfigured) {
          // urządzenie nie zostało skonfigurowane
          fetch('/api/v1/configure/', { method: 'POST' })
            .then((r) => {
              setIsGood(r.ok);
              return r.json();
            })
            .then((d) => {
              setApiConfigureContext(d);
            });
        } else {
          // urządzenie skonfigurowane, można pominąć ten krok
          console.log('Urządzenie skonfigurowane, przejdz do instalacji');
          navigate('/install');
        }
      });

    // sprawdzanie stanu czy już jest skonfigurowane
    const loop = setInterval(() => {
      fetch('/api/v1/configure/')
        .then((r) => r.json())
        .then((data: IApiConfigureGet) => {
          if (data.isConfigured) {
            console.log('Urządzenie skonfigurowane, przejdz do instalacji');
            navigate('/install');
          }
        });
    }, 5000);

    return () => {
      clearInterval(loop);
    };
  }, []);

  return (
    <div className={gstyle.fwcontainer}>
      <LogoFW />
      <div className="mb-5" />
      <h1 className="display-1 text-center">Skonfiguruj urządzenie</h1>
      <div className="mb-5" />
      {isGood === true && apiConfigureContext && (
        <div>
          <div
            className={`${gstyle.qrcode} mb-2`}
            dangerouslySetInnerHTML={{ __html: apiConfigureContext.qrCodeHtml }}
          />
          <div>
            <div className="mb-2">
              <span>Wejdz na</span>
              <u className="mx-1">
                <a href={`${apiConfigureContext.link}?code=${apiConfigureContext.token}`}>{apiConfigureContext.link}</a>
              </u>
              <span>i podaj kod </span>
              <code>{apiConfigureContext.token}</code>
            </div>
            <div>lub zeskanuj kod QR</div>
          </div>
        </div>
      )}
      {isGood === false && <div>Błąd</div>}
    </div>
  );
}

export default ConfigurePage;
